<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <g fill="none" fill-rule="evenodd">
    <path stroke="#FFF" stroke-width=".01" d="M.005.005h23.99v23.99H.005z"/>
    <path [attr.stroke]="color" stroke-linecap="round" stroke-width="2" d="M17 4v8.004A4 4 0 0 1 13.004 16H5"/>
    <path [attr.stroke]="color" stroke-linecap="round" stroke-width="2" d="M9 12l-4 4 4 4"/>
  </g>
</svg>
